// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ZuSX","footer":"ModalUpdate_footer__daZgS"};